import { render, staticRenderFns } from "./MascotaIframePago.vue?vue&type=template&id=22ec862c&"
import script from "./MascotaIframePago.vue?vue&type=script&lang=js&"
export * from "./MascotaIframePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports